module.exports = __webpack_public_path__ + "static/media/onboarding_tour_slide1.49578210.png";